module.exports = "<div v-bind:class=\"{ 'Form__wrapper--collapsed': !show }\" class=Form__wrapper><fieldset :id=sectionId class=Fieldset><template v-if=fdata.legend><header class=Fieldset__header><legend class=Fieldset__legend>{{ fdata.legend }}</legend></header></template><div class=Fieldset__body><partial name=rawhtml></partial></div></fieldset></div>";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-loader.js?raw&engine=jade!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/forms/_sub/fieldsets/standard.vue
// module id = 419
// module chunks = 0